/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".lesson-carousel[_ngcontent-%COMP%]{background-color:#edf6ff}.lesson-carousel[_ngcontent-%COMP%]   h1[_ngcontent-%COMP%]{color:#0080ff;font-size:1.5rem}.lesson-carousel-title[_ngcontent-%COMP%]{font-family:PoppinsSemiBold,Arial,Helvetica,sans-serif;color:#444}.lesson-carousel-progress[_ngcontent-%COMP%]     .progress-bar-component>span{font-family:Inter,Arial,Helvetica,sans-serif;font-weight:700;font-size:1rem!important;color:#899fb5}.lesson-carousel-progress[_ngcontent-%COMP%]     .progress-bar-component .progress{background-color:#a6d4ff}.lesson-carousel[_ngcontent-%COMP%]   .points-md-down[_ngcontent-%COMP%]{margin-left:-1.25rem}"];
export { styles as styles };
//# sourceMappingURL=mini-lesson-section-header.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/home/mini-lesson-section/mini-lesson-section-header/mini-lesson-section-header.component.scss.shim.ngstyle.js
// module id = 1577
// module chunks = 27 28 29